import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import './../../../Styles/Main/ProfilePage/ProfileOrder.scss';
import ProfileOrderBike from './ProfileOrderBike';
import ProfileOrderGeneral from './ProfileOrderGeneral';

function ProfileOrder(props) {

   const [isShowDetail, setIsShowDetail] = useState(false);
   const [arrayBike, setArrayBike] = useState([])

   const showOrderDetail = () => {
      isShowDetail ? setIsShowDetail(false) : setIsShowDetail(true);
      setArrayBike(props.orderedBikes)
   }

   return (
      <div className='profileOrder__body'>
         <div
            className="profileOrder__header headerOrder"
            onClick={showOrderDetail}
         >
            <div
               className={isShowDetail ? "headerOrder__arrow" : "headerOrder__arrow headerOrder__arrow-active"}
            >&#x276F;</div>
            <div className="headerOrder__number text">Order { props.orderNum }</div>
            <div className="headerOrder__data text">{props.date}</div>
            <div className="headerOrder__data text">{props.sum} USD</div>
            <div className="headerOrder__data text">Paid</div>
            <div
               className="headerOrder__data text"
               style={{ border: `${props.statusBorder}`, color: `${props.statusColor}`}}
            >{props.status}</div>
         </div>
         <div className={isShowDetail ? "profileOrder__data" : "profileOrder__data profileOrder__data-hide"}>
            <div className="profileOrder__bikes bikesOrder">
               <div className="bikesOrder__header">
                  <div className="bikesOrder__signature signature">Bike name</div>
                  <div className="bikesOrder__signature signature">Price</div>
                  <div className="bikesOrder__signature signature">Amount days</div>
                  <div className="bikesOrder__signature signature">Summary</div>
               </div>
               <div className="bikesOrder__ordered-bike">
                  {arrayBike.map((item, index) => (
                     <ProfileOrderBike
                        key={index}
                        name={item.name}
                        price={item.price}
                        amountDays={props.amountDays}
                        total={item.total}
                     />
                  ))}
               </div>
            </div>
            <div className="profileOrder__general generalOrder">
               <div className="generalOrder__text">
                  <ProfileOrderGeneral
                     typeRent={props.typeRent}
                     startDate={props.startDate}
                     finishDate={props.finishDate}
                     payment={props.payment}
                     delivery={props.delivery}
                     sum={props.sum}
                  />
               </div>
            </div>
         </div>
      </div>
   );
}
export default ProfileOrder;